import {createSelector} from "@reduxjs/toolkit";

import {configErrorSelector, geoErrorSelector, submitFormErrorSelector, userPersonaErrorSelector} from ".";

export const globalErrorSelector = createSelector(
    [userPersonaErrorSelector, submitFormErrorSelector, configErrorSelector, geoErrorSelector],
    (...errors) => errors.filter((error) => error !== undefined) as string[],
);
